import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, MaskedLine, MonoLabel } from "@/components/Reveal";
import SpotlightCard from "@/components/SpotlightCard";

const CASE_IMAGE =
  "https://images.unsplash.com/photo-1687843040524-ef6dc103b01e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxkYXRhJTIwbm9kZXMlMjBhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fHwxNzg3NzM0MDU4fDA&ixlib=rb-4.1.0&q=85&w=1600";

export default function Work() {
  return (
    <section id="work" className="px-6 sm:px-12 py-32 sm:py-40 border-t border-black/10">
      <div className="grid grid-cols-12 gap-6 items-end mb-16 sm:mb-24">
        <div className="col-span-12 lg:col-span-8">
          <FadeUp>
            <MonoLabel>Selected work</MonoLabel>
          </FadeUp>
          <h2 className="mt-6 font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[1.05]">
            <MaskedLine>Proof, not</MaskedLine>
            <MaskedLine delay={0.1}>
              <span className="text-gradient">promises.</span>
            </MaskedLine>
          </h2>
        </div>
        <FadeUp delay={0.2} className="col-span-12 lg:col-span-4">
          <p className="text-muted-foreground text-base leading-relaxed lg:text-right">
            My most recent case study, from Q3 2026. I update this space every
            three months with the latest work.
          </p>
        </FadeUp>
      </div>

      <FadeUp>
        <Link
          to="/case-study/dubai-it-services"
          className="block"
          data-testid="case-study-card-link"
        >
          <SpotlightCard className="group border border-black/10 bg-card rounded-3xl hover:border-black/25 transition-colors duration-500">
            <div className="grid grid-cols-12" data-testid="case-study-card-1">
              <div className="col-span-12 lg:col-span-7 overflow-hidden">
                <img
                  src={CASE_IMAGE}
                  alt="IT management company case study"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700 aspect-[16/10] lg:aspect-auto"
                />
              </div>
              <div className="col-span-12 lg:col-span-5 p-8 sm:p-12 flex flex-col justify-between gap-10">
                <div>
                  <div className="flex flex-wrap gap-2 mb-6">
                    {["SEO", "AI Overview", "ChatGPT Citations"].map((t) => (
                      <span
                        key={t}
                        className="font-mono text-[10px] tracking-[0.15em] uppercase border border-black/15 px-3 py-1 text-muted-foreground"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <h3 className="font-display font-semibold text-2xl sm:text-3xl tracking-[-0.02em] flex items-start justify-between gap-4">
                    IT management company, UAE
                    <ArrowUpRight className="w-5 h-5 mt-1 shrink-0 text-muted-foreground group-hover:text-primary transition-colors duration-300" />
                  </h3>
                  <p className="mt-5 text-muted-foreground text-base leading-relaxed">
                    Six months of focused work took them from page two to the
                    top three on Google, and into the AI answer box where
                    buyers now see their name first.
                  </p>
                </div>
                <div>
                  <div className="pt-6 border-t border-black/10 flex items-baseline gap-4">
                    <span
                      className="font-display font-extrabold text-4xl sm:text-5xl text-primary tracking-tighter"
                      data-testid="case-study-metric-1"
                    >
                      6 months
                    </span>
                    <span className="font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground">
                      to page one, and cited in the AI answer box
                    </span>
                  </div>
                  <span className="mt-6 inline-flex items-center gap-2 font-mono text-xs tracking-[0.15em] uppercase text-primary">
                    Read the full story
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </div>
            </div>
          </SpotlightCard>
        </Link>
      </FadeUp>
    </section>
  );
}
